import React, { useMemo } from "react";

import { IUploadedFile } from "components/pages/Tasks/components/TaskFiles/TaskFilesPopup/TaskFilesPopup";

import FileRow from "../FileRow/FileRow";

import { IFile } from "types/interfaces/Files";

import { serializeFilesByName } from "utils/formatters/serializeFilesByName";

interface IProps {
  files: IFile[] | IUploadedFile[];
  removeFile: (removedFileId: number) => void;
  maxDisplayingCount?: number;
  isDisabled?: boolean;
  _TODO_onDirectlyClick?: (index: number) => void;
  canRemove?: boolean;
  isFileViewer?: boolean;
}

const FilesList: React.FC<IProps> = ({ files, removeFile, isDisabled, maxDisplayingCount, canRemove = true }) => {
  const slicedFilesByMaxDisplayingCount = useMemo(() => {
    if (!maxDisplayingCount) return [];
    return files.slice(0, maxDisplayingCount);
  }, [maxDisplayingCount, files]);

  return (
    <>
      {(maxDisplayingCount ? slicedFilesByMaxDisplayingCount : files).map((file, i) => (
        <FileRow
          key={file.id}
          file={serializeFilesByName(file) as any}
          remove={removeFile}
          canRemove={!isDisabled && canRemove}
        />
      ))}
    </>
  );
};

export default React.memo(FilesList);
